export default {
  lang: 'French',
  homeScreen: {
    title: 'Gardons cela entre nous', // Product specific
    stayConnected: 'Rester Connecté(e):',
    comingSoon: 'Bientôt disponible',
  },
  notification: {
    newAndNow: 'Nouveautés du moment!',
    alert: 'Alerte',
    message: 'Message',
    contest: 'Concours',
    badge: 'Nouveau Badge',
    'content-update': 'Mise à jour de contenu',
    events: 'Événements',
  },
  loginScreen: {
    title: '',
    welcome: {
      headerTop: 'Bienvenue chez le',
      headerBottom: 'Compagnon de vente BVI Revealed Specialist Program',
    },
    sellingPoints: {
      0: 'Ressource de conversion des ventes au quotidien',
      1: 'Découverte et présentations à fort impact',
      2: "Personnalisez avec le dossier 'favoris'",
      3: 'En ligne, hors ligne - à tout moment et en tout lieu',
      4: 'Partager, connecter, convertir',
      5: 'Vitrine et répertoire interactifs des fournisseurs',
      6: 'Boîte à outils de vente avec toutes les garanties nécessaires pour vendre les BVI comme un PRO',
    },
    emailPrompt:
      'Veuillez entrer votre addresse email pour confirmer que vous êtes un professionnel du voyage.',
    tAndC: {
      agree: 'En continuant, vous acceptez notre',
      privacyPolicy: ' politique de confidentialité',
      and: ' et ',
      termsConditions: 'nos termes et conditions',
    },
    fields: {
      what: 'Quel type de voyage vendez-vous ?',
      what1: 'Quel est le type de voyage n°1 que vous vendez ?',
      what2: 'Quel est le type de voyage #2 que vous vendez ?',
      what3: 'Quel est le type de voyage n°3 que vous vendez ?',
      agency: 'Agence *',
      email: 'E-mail *',
      password: 'Mot de passe *',
      passwordConfirm: 'Confirmez votre mot de passe *',
      firstName: 'Prénom *',
      lastName: 'Nom de famille *',
      agencyName: "Nom de l'agence *",
      city: 'Ville *',
      stateProvince: 'État / Province *',
      salutation: 'Salutation *',
      required: 'Requis',
      invalidEmail: 'Adresse e-mail invalide',
      opt: "Restez en contact ! Oui, j'aimerais m'inscrire aux communications de British Virgin Islands qui me tiendront au courant des actualités, des événements, des incitations, des FAM et plus encore !",
      complete: 'Etape 2 : Complétez votre profil',
      tell: 'Parlez-nous de vous',
      title: "Titre de l'entreprise *",
      host: "Nom de l'agence hôte",
      country: 'Pays / Région',
      select: 'Veuillez sélectionner une option ci-dessous',
      header2: 'Quel(s) segment(s) vendez-vous principalement ?',
      step2: 'Décrivez votre entreprise',
      leisure: 'Loisir',
      corporate: 'Entreprise',
      group: 'Groupe',
      affiliate: 'Quelle est votre affiliation principale ?',
      forgot:
        "Veuillez fournir l'adresse e-mail que vous avez utilisée lors de votre inscription à votre compte Lauderdale Loyalist. Nous vous enverrons un e-mail qui vous permettra de réinitialiser votre mot de passe.",
    },
    noAgent: {
      noAgentButton: 'Je ne suis pas un agent',
      title: 'Merci de votre intérêt pour les îles Vierges britanniques.', // Product specific
      messageWeb: 'Le contenu de ce site est exclusivement reservé aux professionnels du voyage.',
      messageMobile:
        "Une partie du contenu de cette application est exclusivement reservé aux professionnels du voyage, mais n'hésitez pas à naviguer un aperçu de ce que cette application peut offrir en appuyant sur « Continuer ». ",
      continue: 'Continuez',
      visitWebsite: 'Visiter le site web >',
    },
    newUser: 'Nouvel utilisateur',
    register: 'Enregistrer',
    registered: 'Cet e-mail est déjà enregistré',
    forgot: 'Mot de passe oublié',
    header:
      "Veuillez prendre un moment pour compléter toutes les informations ci-dessous, car c'est ce qui remplira votre profil et vos coordonnées.",
    step1: 'Etape 1 : Complétez votre adresse e-mail.',
  },
  welcomeScreen: {
    title: 'Bienvenue au \n BVI Revealed Specialist Program', // Product specific
    helloUser: 'Salut',
    hello: 'Salut',
    fromAgency: 'de {agency}',
    notUser: 'Pas {name}?',
    introOnline:
      "Entraînez-vous immédiatement en ligne ou préchargez le contenu afin qu'il soit toujours disponible pour une utilisation hors ligne !",
    introOffline: 'Vous avez déjà la dernière version préchargée.',
    startTraining: 'Commencez par la formation',
    continueTraining: 'Poursuivre la formation',
    graduated: 'Félicitations, diplômé!',
    downloader: {
      preload: 'Précharger',
      stop: 'Arrêter',
      init: 'Initialiser...',
      lastUpdate: 'Dernière mise à jour:',
    },
  },
  trainingScreens: {
    badge: 'View Badge',
    review: 'revisez',
    start: 'Début',
    continue: 'Continuer',
    restart: 'Redémarrer',
    fastTrack: 'Souhaitez-vous entrer dans le cours Fast Track?',
    fastTrackCopy:
      "Vous ne pouvez répondre à chaque question qu'une seule fois, après avoir répondu à toutes les questions, vous serez noté.",
    fastTrackButton: 'Démarrer le programme Fast Track >',
    incorrect: "C'est incorrect",
    tooManyMistakes:
      'Vous avez fait trop d’erreurs. Nous vous recommandons de visiter la section de formation régulière.',
    next: 'Question suivante',
    no: 'Non merci',
    yes: "Oui s'il vous plaît",
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Achevée',
    unlock: 'Déverrouillez ce chapitre en terminant le chapitre de formation {number}.',
    unlockSubtitle: 'Débloquez plus de chapitres en terminant les chapitres de formation.',
    allUnlocked: 'Vous avez déverrouillé tous les chapitres !',
    certificate: 'Certificat',
    chapterComplete: 'Chapitre terminé !',
    courseComplete: 'Cours terminé !',
    endReached: 'Vous avez atteint la fin',
    retainEnd:
      "Utilisez la barre supérieure pour naviguer dans ce chapitre ou appuyez sur le bouton Précédent pour revenir à l'aperçu.",
    watchListenRead: 'Regardez, écoutez et lisez plus',
    trouble: 'Il semble que vous ayez des problèmes, souhaitez-vous ignorer cette question?',
    confirm: 'Confirmez votre réponse',
    choose: 'Veuillez choisir une réponse',
    skip: 'Ignorer la question',
    retry: 'Réessayer',
  },
  nav: {
    home: 'Accueil',
    train: 'Formation',
    retain: 'Decouvrir',
    rewards: 'Rewards',
    directory: 'Agenda',
    promote: 'Promouvoir',
    sell: 'Boite a outils',
    info: 'Info',
    media: 'Média',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Bulletin',
    accountSettings: 'Paramètres du compte',
    messages: 'Message',
    search: 'Rechercher',
  },
  contentHeaders: {
    train: 'Nos modules de formation',
    retain: 'Conserver',
    subapps: 'Mini modules de nos destinations partenaires',
  },
  pageDescriptions: {
    train: '',
    retain:
      "Votre ressource incontournable pour conserver vos connaissances d'expert et permettre vos efforts de vente. Utilisez cette zone pour répondre de manière experte à une question sur un produit ou même comme présentation de vente impromptue - à tout moment, n'importe où et depuis n'importe quel appareil.",
    promote: '',
    sell: '',
    favorites: 'Vérifiez votre contenu préféré personnellement',
    search: 'Naviguez tout le contenu',
    subapps: 'En savoir plus sur nos partenaires',
  },
  general: {
    yes: 'Yes',
    no: 'No',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    logIn: 'Se Connecter',
    logOut: 'Se déconnecter',
    viewItem: 'Visualiser',
    imageNotFound: 'Image non trouvée',
    noResultsFor: "Aucun résultat n'a été trouvé pour :",
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez pas encore reçu de messages !",
    resultsFor: 'Des résultats pour :',
    showAll: 'Afficher tout',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 Page non trouvée !',
    oops: 'Euh oh...',
    overview: "Retour à l'aperçu",
    complete: 'Cours achevé !',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    chapterComplete: 'Chapter complete!',
    courseComplete: 'Course complete!',
    rewards: 'Lire la suite >',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site Web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faire tourner les cadrans pour faire correspondre à la réponse',
    fitb: 'Remplir les espaces vides',
    flip: 'Changer le numéro pour correspondre à la réponse',
    multipleChoice: 'Choisir la (les) bonne (s) réponse (s)',
    slider: "Choisir la bonne réponse à l'aide du curseur",
    map: 'Répondre à la question en appuyant sur le bon emplacement sur la carte',
    dropdown: 'Choisir...',
    true: 'Vrai',
    false: 'Faux',
  },
  reportCard: {
    download: 'Télécharger',
    email: 'Email',
    print: 'Impression',
  },
  cookies: {
    consent: 'ACCEPTER',
    optout: 'Se désengager',
    settings: 'Paramètres de confidentialité ',
    message:
      'Vous ne nous avez rien communiqué à propos de vos préférences en matière de confidentialité des données !',
    disabled: "Il semble que vous ayez désactivé l'utilisation des cookies.",
    use: "Le {Nom de l’app} exige l'utilisation de cookies pour vous offrir la meilleure expérience.",
    details: 'À quoi servent les cookies ?',
    enable: 'Voir comment activer vos cookies {ici}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connecté",
    title: 'Vous devez être connecté pour visualiser ce contenu',
    guest: 'L’invité',
  },
  demo: {
    message: 'Ce site Web est une démonstration du produit final.',
    consent: '',
  },
  share: {
    header: '',
    download: 'Télécharger',
  },
  errors: {
    comingSoon: 'Bientôt disponible...',
    missingContent: 'Le contenu demandé est toujours en production.',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "Il semble que vous essayez d'accéder à {appName} à partir d'un appareil mobile.",
    body: "Pour télécharger ce programme, visitez tout simplement l’app store et recherchez {appName} ou cliquez sur l'un des boutons ci-dessous",
    benefits: {
      header: 'Cela vous fournira :',
      1: 'La portabilité',
      2: 'Pas besoin de WiFi, entraînez-vous quand et où il vous convient',
      3: 'Des outils et des ressources de vente à votre portée',
    },
  },
  sharing: {
    twitter: 'Pensez à prendre vos prochaines vacances aux îles Vierges britanniques…',
    imageEmailSubject: 'Juste pour vous, de BVI Revealed Specialist Program ... Idées de vacances',
    imageEmailCopy:
      'Prenez une minute pour consulter le contenu des vacances révélé des secrets des BVI ci-joint…',
    videoEmailSubject: 'Cool BVI Secrets a révélé des idées de vacances partagées avec vous!',
    videoEmailCopy:
      'Je pensais que vous apprécieriez cette vidéo de vacances BVI Revealed Specialist Program. Cliquez simplement sur le lien ci-dessous pour regarder. Prendre plaisir!',
    infographicEmailSubject: 'Partager quelque chose sur les secrets des BVI...',
  },
  search: {
    pages: 'Pages',
    resources: 'Ressources',
  },
};
